// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QIkP","content":"styles_content__2X0qf","tableWrap":"styles_tableWrap__2yu91"};